/**
 * @file Utility that needs description.
 * @copyright Copyright (c) 2018-present, Graham Fairweather
 * @module _slice
 */

import _methodize from './_methodize';

export default _methodize(Array.prototype.slice);
